export default [
    {
        path: '/company',
        name: 'companys',
        component: () => import('@/views/company/CompaniesView.vue')
    },
    {
        path: '/company/:id',
        name: 'company',
        component: () => import('@/views/company/CompanyView.vue')
    },
    {
        path: '/company/:id/add-member',
        name: 'add-member',
        component: () => import('@/views/company/AddMemberView.vue')
    }
]
